import "./PancasilaYouthZone.module.css";
import Header from "@/reusable_sections/Header";
import StickyInternalNavigation from "./sections/StickyInternalNavigation";
import RemoteTypesWeSupport from "./sections/RemoteTypesWeSupport";
import Footer from "@/reusable_sections/Footer";
export default function PancasilaYouthZonePage() {
  return <div>
      <Header />
      <StickyInternalNavigation />
      <RemoteTypesWeSupport />
      <Footer />
    </div>;
}